import React, { useState } from 'react';
import BookForm from '../../components/home/FormComponents/BookForm';
import BookDonationService from '../../services/home/BookDonationManager';
import { motion } from "framer-motion";
import toast from 'react-hot-toast';


const BookDonationForm = () => {
  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');

  const handleDonationSubmit = async (formData) => {
    setLoading(true);
    setSuccessMessage('');
    setErrorMessage('');
    try {
      await BookDonationService.createDonation(formData);
      setSuccessMessage('🎉 Thank you! Your donation has been recorded.');
      toast.success("🎉 Thank you! Your donation has been recorded.We will connect with you shortly");
      setLoading(false);
    } catch (error) {
      console.error('Donation error:', error);
      setErrorMessage('🚨 Oops! Something went wrong. Please try again later.');
      toast.error("🚨 Oops! Something went wrong. Please try again later.");
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col items-center justify-center p-0">
      <BookForm type="donation" onSubmit={handleDonationSubmit} />

      {loading && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          className="mt-4 text-gray-600"
        >
          Submitting your donation...
        </motion.div>
      )}

      {successMessage && (
        <motion.div
          initial={{ scale: 0.8, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          className="mt-4 text-green-600 font-medium"
        >
          {successMessage}
        </motion.div>
      )}

      {errorMessage && (
        <motion.div
          initial={{ scale: 0.8, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          className="mt-4 text-red-600 font-medium"
        >
          {errorMessage}
        </motion.div>
      )}
    </div>
  );
};

export default BookDonationForm;
